module.exports = __webpack_public_path__ + "img/mobile1.07ec2453.svg";